import React, { useState } from "react";
import EyeIcon from "../../icons/EyeIcon";
import HideEyeIcon from "../../icons/HideEyeIcon";
import Lock from "../../icons/Lock";

import { EyeOff , Eye} from "lucide-react";
const ChangePasswordField = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  autoComplete,
  className,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="form-group">
      {label && <label htmlFor={id}>{label}</label>}
      <div
        className={`input-container d-flex align-items-center input_icon_wrap ${
          isFocused ? "focused" : ""
        }`}
        style={{ position: "relative" }} // Add relative positioning for absolute child
      >
        <input
          type={passwordVisible ? "text" : "password"}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          onFocus={() => setIsFocused(true)}
          placeholder={placeholder}
        //   style={{
        //     borderRight: value && value.length > 0
        //       ? isFocused
        //         ? "0px solid #6C5DD3"
        //         : "0px solid #D8DAE5"
        //       : isFocused
        //       ? "1px solid #6C5DD3"
        //       : "1px solid #D8DAE5",
        //     borderRadius: value && value.length > 0 ? "8px 0 0 8px" : "8px",
        //     paddingRight: "40px", // Add padding to prevent text overlap with icon
        //     width: "100%", // Ensure input takes full width
        //   }}
          autoComplete={autoComplete || "off"}
          className={className}
        />
        {value && value.length > 0 && (
          <div
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
            onClick={() => setPasswordVisible(!passwordVisible)}
          >
            {passwordVisible ? <EyeOff size={18} color="#8F95B2"/> : <Eye size={18} color="#8F95B2"/>}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangePasswordField;